import { useCallback } from 'react';

import { ValidationItems, useWatch } from '@kanda-libs/ks-component-ts';

import { GROSS_INCOME_NAME } from './constants';

export default function useHouseholdAnnualIncomeValidation(): ValidationItems {
  const grossAnnualIncome = useWatch({ name: GROSS_INCOME_NAME });

  const validateHouseholdIncome = useCallback(
    (householdAnnualIncome) =>
      householdAnnualIncome &&
      grossAnnualIncome &&
      householdAnnualIncome >= grossAnnualIncome,
    [grossAnnualIncome],
  );

  return {
    min: { value: 1000000, message: 'Amount must be greater than £10,000' },
    required: {
      value: true,
      message: 'Household annual income is required',
    },
    validate: {
      value: (value) => validateHouseholdIncome(value),
      message:
        'Household annual income cannot be lower than your gross annual income',
    },
  };
}
